<!--
 * @Author: your name
 * @Date: 2021-07-09 09:38:54
 * @LastEditTime: 2022-04-21 11:06:06
 * @LastEditors: Please set LastEditors
 * @Description: In User Settings Edit
 * @FilePath: \smart-community\src\App.vue
-->
<template>
  <el-config-provider :locale="locale" :button="config">
    <router-view/>
  </el-config-provider>
</template>
<script>
import zhCn from "element-plus/lib/locale/lang/zh-cn";
import {
  toRefs,
  reactive,
  defineComponent
} from 'vue';
export default defineComponent({
  setup() {
    // 切换为中文
    const locale = zhCn;
    const configData = reactive({
      autoInsertSpace: true
    });
    const config = toRefs(configData);
    return { locale, config };
  }
});
</script>
<style lang="scss">
@import url('~@/assets/style/reset.scss');
</style>
